import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { _get_profile } from "../common/axios_services";
import { fetchData, profileData, setUserData } from "../slices/profileSlice";
import { showErrorNotification } from "../common/utils/notification";

const useUserProfile = () => {
  const dispatch = useDispatch();
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUserProfile = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await _get_profile();
      const userData = response?.data?.data;
      dispatch(setUserData(userData));
      dispatch(fetchData(true));
      dispatch(profileData(userData));
      setUserProfile(userData);
      return userData;
    } catch (err) {
      setError(err);
      showErrorNotification(
        err.message || "Failed to fetch user profile",
        "Error"
      );
      dispatch(fetchData(false));
      dispatch(profileData(false));
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  return { userProfile, loading, error, refetchUserProfile: fetchUserProfile };
};

export default useUserProfile;
